export enum FolderLevel {
    RootLevel,
    BusinessStructure,
    ProductFamily,
    Product,
    Configuration,
    TeamPlay
}